import en from "@src/locales/en/en.json";
import pt from "@src/locales/pt/pt.json";
import it from "@src/locales/it/it.json";
import es from "@src/locales/es/es.json";
import fr from "@src/locales/fr/fr.json";

export const languages = {
    en,
    pt,
    it,
    es,
    fr,
};